module.exports = __webpack_public_path__ + "static/ruggear-a7696f01ca76526e79288e8148b140e8.svg";